import { DataBean } from "../DataBean";

export class CustomerAddress extends DataBean {



    public async deleteCustomerAddress(idCustomerAddress: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteCustomerAddress_Number", [idCustomerAddress]);
    }

    public async getCustomerAddressCatalog(idAccount: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getCustomerAddressCatalog_Number_Number_Number", [idAccount, page, recordsPerPage]);
    }

}